import { useSelector } from 'react-redux';

import { getCustomerName } from 'common/helpers/customerHelper';
import { getProfileHref } from 'common/helpers/routerHelper';
import Logout from 'profile/common/Logout';
import { useLocalization } from 'redux/localization/utils/hooks';

const LoggedIn = () => {
  let firstName;
  let email;

  const customer = useSelector((state) => state.customer.data);
  const settings = useSelector((state) => state.setting.data);
  const { t } = useLocalization();

  const { hasReservations, hasClubs, hasAllocations } = settings;

  if (!customer) {
    return null;
  }

  if (customer) {
    firstName = customer.firstName;
    email = customer.emails[0].email;
  }

  let accountGreeting = t('customerAccount.login.accountGreeting', {
    firstName
  });
  if (!firstName) {
    accountGreeting = t('customerAccount.login.accountGreetingNoName');
  }

  const hasNotifications = customer.notifications?.length > 0;
  const name = getCustomerName(customer);

  return (
    <div
      className="c7-user-nav__account"
      aria-expanded="false"
      aria-haspopup="true"
    >
      <a
        href={getProfileHref('/')}
        className="c7-user-nav__account__name"
        data-testid="nav-account-name-link"
      >
        {accountGreeting}
        <span className="c7-sr-only">
          , {t('general.accessibility.viewYourAccount')}.
        </span>
        {hasNotifications && (
          <span className="c7-account-notification">
            <span className="c7-sr-only">
              {t('general.accessibility.yourAccountHasItems')}
            </span>
          </span>
        )}
        <svg
          aria-hidden="true"
          focusable="false"
          role="presentation"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </a>

      <div className="c7-user-nav__account__dropdown">
        <div className="c7-user-nav__account__dropdown__header">
          {name && (
            <p>
              <a href={getProfileHref('/')}>
                {name}
                {email && <span>{email}</span>}
              </a>
            </p>
          )}
          {!name && (
            <p>
              <a href={getProfileHref('/')}>{email}</a>
            </p>
          )}
        </div>
        <ul>
          <li>
            <a href={getProfileHref('/')}>
              {t('customerAccount.general.dashboard')}
            </a>
          </li>
          {hasClubs && (
            <li>
              <a href={getProfileHref('/club-membership')}>
                {t('clubSignup.membership.clubMemberships')}
              </a>
            </li>
          )}
          <li>
            <a href={getProfileHref('/order-history')}>
              {t('customerAccount.orders.orderHistory')}
            </a>
          </li>
          {hasReservations && (
            <li>
              <a href={getProfileHref('/reservation')}>
                {t('customerAccount.reservations.reservations')}
              </a>
            </li>
          )}
          {hasAllocations && (
            <li>
              <a href={getProfileHref('/allocation')}>
                {t('customerAccount.general.allocations')}
              </a>
            </li>
          )}
          <li>
            <a href={getProfileHref('/account')}>
              {t('customerAccount.details.accountDetails')}
            </a>
          </li>
        </ul>
        <Logout className="c7-user-nav__account__dropdown__logout" />
      </div>
    </div>
  );
};

export default LoggedIn;
